import {ComponentProps} from "react";
import {FileDownloadButton} from "./FileDownloadButton";
import {useUser} from "../custom-hooks/useUser";

export const AccidentsExportButton = (props: ComponentProps<typeof FileDownloadButton>) => {
    const {isEjecutivo, usuario} = useUser();

    if (!isEjecutivo && usuario !== "efi") return null;

    return <FileDownloadButton {...props} />;
};
